import "./HomeV1.scss";
import SharedCard from "./v1/sharedCard/SharedCard";
import Card from "./v1/card/Card";
import { fetchDashboardStat } from "../../redux/slices/dashboardSlice";

import React, { useEffect, useState } from "react";
import InfoModal from "../../components/modal/info-modal/InfoModal";
import DataStores from "../../components/home/datastores/Datastores";
import DataFlows from "../../components/home/data-flows/DataFlow";
import SecurityIssues from "../../components/home/security-issues/SecurityIssues";
import Achievements from "../../components/home/achievements/Achievements";
import ImpactedDatastores from "../../components/home/impacted-datastores/ImpactedDatastores";
import Trend from "../../components/home/trends/Trends";
import { getDatastoresByFilterApi } from "../../apis";
import { useDispatch, useSelector } from "react-redux";
import { getCustomerId } from "../../utils/SessionHelper";
import { addIndex, colorRiskData } from "../../utils/dataHandler";
import Inventory from "./v1/inventory/Inventory";
import CloudEnvIssues from "./v1/clound-env-issues/CloudEnvIssues";
import {
  firstAccountStatStatus,
  listRiskPlot,
} from "../../redux/slices/dashboardSlice";
import { useHistory } from "react-router-dom";
import DashboardStats from "./dashboard-stats/DashboardStats";
import { isJsonEmpty, numberFormatter } from "../../utils/utils";
import FirstAccountStats from "./dashboard-stats/FirstAccountStats";
import FirstTimeLoginAccount from "../cards/account/FirstTimeLoginAccount";
import SensitiveData from "./v1/sensitiveData/SensitiveData";
import DataPolicyViolation from "./v1/dataPolicyViolation/DataPolicyViolation";
import { useTheme } from "@mui/material";
import Box from "../common/Box";
import ImpactedDataStoresPanel from "../dashboard-widgets/ImpactedDataStoresPanel";
import TicketStatusCard from "../dashboard-widgets/TicketStatusCard";
import GeoDistributionCard from "../dashboard-widgets/GeoDistributionCard";
import AchievementsCard from "../dashboard-widgets/AchievementsCard";
import UsageCard from "../dashboard-widgets/UsageCard";
import DataViolationBarChart from "../dashboard-widgets/DataViolationBarChart";
import CloudRiskCard from "../dashboard-widgets/CloudRiskCard";
import RiskTrendsCard from "../dashboard-widgets/RiskTrendsCard";
import PolicyBarChart from "../dashboard-widgets/PolicyBarChart";
import Insights from "../common/Insights";
import PolicyStoreDetailsDrawer from "../policy-store-details-drawer/PolicyStoreDetailsDrawer";
import { useContext } from "react";
import { AppContext } from "../../context/appContext";
import { DASHBOARD_AI_VIEW, DASHBOARD_DATA_VIEW } from "../constants/constants";
import TrainingDataCard from "../dashboard-widgets/TrainingDataCard";
import SensitiveDataCard from "../dashboard-widgets/SensitiveDataCard";

const NewHome = ({ setPath, tab, selectedAccount, isIssueViewVisible }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const expandedSidebar = useSelector((state) => state.dashboard.sidebar);

  const limit = 10;
  const [risktype, setRisktype] = useState("high");
  const [severity, setSeverity] = useState(null);
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [page, setPage] = useState(1);
  const [bars, setBars] = useState([]);
  const [selectedBar, setSelectedBar] = useState({});
  const [isBarClicked, setIsBarClicked] = useState(false);
  const [start, setStart] = useState(1);
  const [end, setEnd] = useState(10);
  const [showInfoModal, setShowInfoModal] = useState(false);
  const [infoModalData, setInfoModalData] = useState(false);
  const [dataStores, setDatastores] = useState([]);
  const [issues, setIssues] = useState([]);
  const [dataRisks, setDataRisks] = useState([]);
  const [totalDatastoresCount, setTotalDatastoresCount] = useState(0);
  const [issuesCount, setIssuesCount] = useState(0);
  const [datastoreIds, setDatastoreIds] = useState([]);
  const [hoveredDatastoreIds, setHoveredDatastoreIds] = useState([]);
  const [datastore, setDatastore] = useState({});
  const [loading, setLoading] = useState(false);
  const [datastoresLoading, setDatastoresLoading] = useState(false);
  const [riskplotLoading, setRiskplotLoading] = useState(false);
  const [filteredDatastores, setFiltersDatastores] = useState([]);
  const [filteredPolicyDatastores, setPolicyFiltersDatastores] = useState([]);
  const [stats, updateStats] = useState([]);
  const showShadowAI = localStorage.getItem("showShadowAI");
  const [dashboardCards, setDashboardCards] = useState([
    {
      id: "sensitive",
      title: "Sensitive Data",
      count: 0,
      clickable: true,
    },
    {
      id: "SHADOW",
      title: "Shadow Data Store",
      count: 0,
      clickable: true,
    },
    {
      id: "SHADOW_AI",
      title: "Shadow AI",
      count: 0,
      clickable: true,
    },
    {
      id: "violatingPolicies",
      title: "Violating Policies",
      count: 0,
    },
    {
      id: "cloudEnvIssues",
      title: "Cloud Risk Exposures",
      count: 0,
    },
  ]);

  const riskPlot = useSelector((state) => state.dashboard.riskPlot);
  const [breachCost, setBreachCost] = useState(0);

  const firstAccountStatus = useSelector(
    (state) => state.dashboard.firstAccountStatus
  );
  const accountAvailable = useSelector(
    (state) => state.account.accountAvailable
  );

  const nextPage = () => {
    setPage(page + 1);
  };

  const prevPage = () => {
    setPage(page - 1);
  };

  const getDashboardStats = async (selectedAccount) => {
    const payload = {
      customerId: getCustomerId(),
      cloudAccountId:
        selectedAccount.value === "all" ? null : selectedAccount.value,
    };
    let resp = await dispatch(fetchDashboardStat(payload));
    if (resp && resp.payload && !resp.payload.err) {
      updateStats(resp.payload);
    }
  };

  useEffect(() => {
    getDashboardStats(selectedAccount);
  }, [selectedAccount]);

  useEffect(() => {
    updateCards();
  }, [stats]);

  const updateCards = () => {
    let updatedstats = [...dashboardCards];

    const data = stats?.inventory?.data;
    const violatingPolicyCount = stats?.inventory?.policy?.stores;
    if (data) {
      updatedstats.map((card) => {
        switch (card.id) {
          case "sensitive":
            card.count = data[card.id] ? data[card.id] : 0;
            break;
          case "SHADOW":
            card.count = data["shadow"] ? data["shadow"] : 0;
            break;
          case "SHADOW_AI":
            card.count = data["shadowAI"] ? data["shadowAI"] : 0;
            break;
          case "cloudEnvIssues":
            card.count = data[card.id] ? data[card.id] : 0;
            break;
          case "violatingPolicies":
            card.count = violatingPolicyCount;

            break;
          default:
        }
      });
    }
    if (showShadowAI == "false") {
      updatedstats = updatedstats.filter((card) => card.title !== "Shadow AI");
    }
    setDashboardCards([...updatedstats]);
  };

  // const getDataStores = async () => {
  //   setDatastoresLoading(true);
  //   const payload = {
  //     customerId: getCustomerId(),
  //     limit: limit,
  //     page: page,
  //     datastoreIds: datastoreIds,
  //     severity:
  //       !severity || severity.includes("TOTAL DATA STORES")
  //         ? null
  //         : severity.replaceAll(" ", "_"),
  //   };
  //   let res = await getDataStoresApi(payload);
  //   if (!res.data) return;
  //   setTotalDatastoresCount(res.count);
  //   res = addIndex(res.data);
  //   // res[0].numSecurityIssues = 100;
  //   // res[0].numAttackPath = 100;
  //   setDatastores(res);
  //   setFiltersDatastores(res);
  //   if (res.length) {
  //     setSelectedBar(res[0]);
  //   }
  //   setDatastoresLoading(false);
  // };

  const theme = useTheme();

  const styles = {
    pageParent: {
      display: "flex",
      width: "100%",
      height: "auto",
    },
    sideBar: {
      display: "flex",
      justifyContent: "center",
      minWidth: "52px",
      borderRight: `1px solid ${theme.palette.surfaceMain.main}`,
    },
    homeContainer: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(3),
    },
    contentPanel: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
      paddingBottom: theme.spacing(2),
    },
    contentRow1: {
      display: "flex",
      width: "100%",
      gap: theme.spacing(2),
    },
    donutCardContainer: {
      overflow: "visible",
      backgroundColor: theme.palette.surface10.main,
      borderRadius: theme.spacing(0.5),
      width: "70%",
      display: "flex",
    },
    usageRiskContainer: {
      minWidth: "30%",
      width: "30%",
      display: "flex",
      flexDirection: "column",
      gap: theme.spacing(2),
    },
    barContainer: {
      width: "70%",
      display: "flex",
      gap: theme.spacing(2),
    },
    barCard: {
      width: "100%",
      paddingY: theme.spacing(1),
      backgroundColor: theme.palette.surface10.main,
      borderRadius: theme.spacing(0.5),
    },
    cardBgColor: {
      backgroundColor: theme.palette.surface10.main,
      borderRadius: theme.spacing(0.5),
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(1),
    },
    insightsBar: {
      width: "24px",
      display: "flex",
      justifyContent: "end",
    },
    logo: {
      marginTop: "22px",
      cursor: "pointer",
    },
    geoCard: {
      width: "100%",
      backgroundColor: theme.palette.surface10.main,
      borderRadius: theme.spacing(0.5),
    },
    geoDetailsCard: {
      width: "40%",
      marginLeft: "auto",
    },
  };

  const {
    dashboardViewLense,
    openPolicyStoreDetailDrawer,
    setOpenPolicyStoreDetailDrawer,
  } = useContext(AppContext);

  const getFirstAccountStats = () => {
    const payload = {
      customerId: getCustomerId(),
    };

    dispatch(firstAccountStatStatus(payload));
  };

  const getDatastoresByFilter = async () => {
    setDatastoresLoading(true);
    const payload = {
      customerId: getCustomerId(),
      limit: limit,
      page: page,
      datastoreIds: datastoreIds,
      filters: "all",
      limit: 10,
      page: 1,
      severity:
        !severity || severity.includes("TOTAL DATA STORES")
          ? null
          : severity.replaceAll(" ", "_"),
      cloudAccountId:
        selectedAccount.value === "all" ? null : selectedAccount.value,
    };
    let res = await getDatastoresByFilterApi(payload);
    if (res.err) {
      setFiltersDatastores([]);
      setDatastoresLoading(false);
    } else {
      if (res.data) {
        setFiltersDatastores(res.data);
      } else {
        setFiltersDatastores(res);
      }

      if (res.length) {
        setSelectedBar(res[0]);
      }
      setDatastoresLoading(false);
    }
  };

  const getDatastoresByPolicyFilter = async () => {
    setDatastoresLoading(true);
    const payload = {
      customerId: getCustomerId(),
      limit: limit,
      page: page,
      datastoreIds: datastoreIds,
      filters: "non-compliant",
      limit: 10,
      page: 1,
      severity:
        !severity || severity.includes("TOTAL DATA STORES")
          ? null
          : severity.replaceAll(" ", "_"),
      cloudAccountId:
        selectedAccount.value === "all" ? null : selectedAccount.value,
    };
    let res = await getDatastoresByFilterApi(payload);
    if (res.err) {
      setFiltersDatastores([]);
      setDatastoresLoading(false);
    } else {
      if (res.data) {
        setPolicyFiltersDatastores(res.data);
      } else {
        setPolicyFiltersDatastores(res);
      }
      if (res.length) {
        setSelectedBar(res[0]);
      }
      setDatastoresLoading(false);
    }
  };

  const filterBars = (ids) => {
    setDatastoreIds(ids);
  };

  useEffect(() => {
    if (riskPlot) {
      let data = riskPlot;
      if (!data || isJsonEmpty(data)) return;
      data = colorRiskData(addIndex(data));
      setDataRisks(data);
    }
  }, [riskPlot]);

  const dataView = dashboardViewLense === DASHBOARD_DATA_VIEW;

  // const getIssues = async () => {
  //   setDatastoresLoading(true);
  //   const payload = {
  //     customerId: getCustomerId(),
  //     limit: limit,
  //     page: page,
  //     severity:
  //       !severity || severity.includes("TOTAL ISSUES")
  //         ? null
  //         : severity.replaceAll(" ", "_"),
  //   };
  //   let res = await getIssuesApi(payload);
  //   if (!res.data) return;
  //   setIssuesCount(res.count);
  //   res = addIndex(res.data);
  //   setIssues(res);
  //   if (res.length) {
  //     setSelectedBar(res[0]);
  //   }
  //   setDatastoresLoading(false);
  // };

  const getDataRiskPlot = () => {
    setRiskplotLoading(true);
    const payload = {
      customerId: getCustomerId(),
      severity:
        !severity || severity.includes("TOTAL DATA STORES")
          ? null
          : severity.replaceAll(" ", "_"),
      cloudAccountId:
        selectedAccount.value === "all" ? null : selectedAccount.value,
    };
    dispatch(listRiskPlot(payload));
    setRiskplotLoading(false);
  };

  const vulDatastores = () => {
    let vunerabilityDataStores_ = issues;
    if (severity) {
      vunerabilityDataStores_ = issues.filter((i) => severity === i.severity);
    }
    const data = vunerabilityDataStores_.slice(start - 1, end);
    return data;
  };

  const datastores = () => {
    let data_ = dataStores;
    if (severity) {
      data_ = dataStores.filter((i) => severity === i.severity);
    }
    const data = data_.slice(start - 1, end);
    return data;
  };

  const handleBarData = () => {
    const data = tab === 2 ? vulDatastores() : datastores();
    setBars(data);
    sessionStorage.setItem("selected_bar", JSON.stringify(data[0]));
  };

  const handleInfoModal = (visible, data) => {
    setInfoModalData(data);
    setShowInfoModal(visible);
  };

  useEffect(() => {
    getDatastoresByFilter();
    getDatastoresByPolicyFilter();
    // if (
    //   selectedFilter === "non-compliant" ||
    //   selectedFilter === "active-anomaly"
    // ) {
    //   getDatastoresByFilter();
    // } else {
    //   getDataStores();
    // }
  }, [selectedFilter, selectedAccount]);

  useEffect(() => {
    handleBarData();
  }, [page, risktype]);

  useEffect(() => {
    setStart(1);
    setEnd(10);
    setPage(1);
    handleBarData();
  }, [severity]);

  useEffect(() => {
    setSeverity(null);
    setStart(1);
    setEnd(10);
    setPage(1);

    handleBarData();
  }, [tab]);

  useEffect(() => {
    getDataRiskPlot();

    // if (tab === 1) {
    //   getDatastoresByFilter();
    //   // getDataStores();
    // } else {
    //   getIssues();
    // }
  }, [page, tab, selectedAccount, severity, datastoreIds]);

  useEffect(() => {
    setPath(window.location.pathname);
    document.title = "Cloud Defense - Dashboard";
    getFirstAccountStats();
  }, []);

  const handleCardClick = (card) => {
    history.push("/datastore/filter/" + card.id);
  };

  return (
    <div>
      {accountAvailable === false ? (
        <FirstTimeLoginAccount />
      ) : (
        <Box sx={styles.pageParent}>
          <Box sx={styles.homeContainer}>
            <Box sx={styles.contentPanel}>
              <Box sx={styles.contentRow1}>
                <ImpactedDataStoresPanel />
                <Box sx={styles.usageRiskContainer}>
                  <UsageCard />
                  {dashboardViewLense === DASHBOARD_DATA_VIEW && (
                    <TicketStatusCard />
                  )}
                </Box>
              </Box>
              <Box sx={styles.contentRow1}>
                <Box sx={styles.barContainer}>
                  <PolicyBarChart />
                  <DataViolationBarChart />
                </Box>
                <Box
                  sx={{ ...styles.usageRiskContainer, ...styles.cardBgColor }}
                >
                  <CloudRiskCard />
                </Box>
              </Box>
              <Box sx={styles.contentRow1}>
                <Box sx={styles.geoCard}>
                  <GeoDistributionCard />
                </Box>
              </Box>
              <Box sx={styles.contentRow1}>
                {dataView ? (
                  <>
                    <RiskTrendsCard expandedSidebar={expandedSidebar} />
                    <AchievementsCard />
                  </>
                ) : (
                  <>
                    <TrainingDataCard />
                    <SensitiveDataCard />
                  </>
                )}
              </Box>
            </Box>
          </Box>

          <PolicyStoreDetailsDrawer
            open={openPolicyStoreDetailDrawer}
            setOpen={setOpenPolicyStoreDetailDrawer}
            anchor="right"
          />
        </Box>
      )}
    </div>
  );
};

export default NewHome;
